import { useEffect, useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { Loader2, Trash2 } from "lucide-react";
import { useAuth } from "@/auth/AuthContext";

const API = `${process.env.REACT_APP_BACKEND_URL}/api/customers`;

export const BlacklistTab = () => {
  const [items, setItems] = useState(null);
  const isOwner = (useAuth() || {}).user?.role === "owner";
  const load = () => axios.get(`${API}/blacklist`).then((r) => setItems(r.data.items || [])).catch(() => setItems([]));
  useEffect(() => { load(); }, []);
  const remove = async (b) => {
    if (!window.confirm(`Scoți ${b.name || b.phone || b.email} din blacklist?`)) return;
    try { await axios.post(`${API}/blacklist/${b.id}/remove`); toast.success("Scos din blacklist"); load(); }
    catch (e) { toast.error(e.response?.data?.detail || e.message); }
  };
  if (!items) return <Loader2 className="h-5 w-5 animate-spin text-zinc-500" />;
  if (!items.length) return <p data-testid="blacklist-empty" className="text-sm text-zinc-500">Niciun client în blacklist.</p>;
  return (
    <div data-testid="blacklist-tab" className="overflow-x-auto rounded-xl border border-zinc-800">
      <table className="w-full text-xs">
        <thead className="bg-zinc-900/80 text-[10px] uppercase tracking-wider text-zinc-500">
          <tr><th className="px-3 py-2 text-left">Client</th><th className="px-3 py-2 text-left">Telefon / Email</th>
            <th className="px-3 py-2 text-left">Motiv</th><th className="px-3 py-2 text-left">Comandă</th><th className="px-3 py-2 text-left">Adăugat</th><th /></tr>
        </thead>
        <tbody>
          {items.map((b) => (
            <tr key={b.id} data-testid={`blacklist-row-${b.id}`} className="border-t border-zinc-900 align-top">
              <td className="px-3 py-2 font-medium text-zinc-100">{b.name || "—"}</td>
              <td className="px-3 py-2 text-zinc-400"><div>{b.phone || "—"}</div><div className="text-[10px]">{b.email || ""}</div></td>
              <td data-testid={`blacklist-reason-${b.id}`} className="max-w-md whitespace-pre-wrap px-3 py-2 text-rose-200">{b.reason}</td>
              <td className="px-3 py-2 text-zinc-400">{b.order_id ? `#${b.order_id}` : "—"}</td>
              <td className="px-3 py-2 text-zinc-500">{(b.created_at || "").slice(0, 10)}</td>
              <td className="px-3 py-2 text-right">
                {isOwner && <button onClick={() => remove(b)} data-testid={`blacklist-remove-${b.id}`} title="Scoate din blacklist" className="rounded p-1 text-zinc-500 hover:bg-zinc-800 hover:text-rose-300"><Trash2 className="h-3.5 w-3.5" /></button>}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};
